import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

export const serviceCaisseGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasAccess('SERVICE_CAISSE')) {
    return true;
  }
  router.navigate(['/authentication/signin']);
  return false;
};
